import React, { useEffect, useState, useContext, useRef } from 'react';
import { Outlet, Link } from "react-router-dom";
import images from '../../services/images';
import appSession from '../../services/session';
import helpers from '../../services/helpers';
import SideMenu from './SideMenu';
import PolarCareSideMenu from './PolarCareSideMenu';
import { MdHandyman } from "react-icons/md";
import ProfileContext from '../../services/profileContext';
import ProtectedComponent from '../../services/protectedComponent';
import DropDownNavPlus from './DropDownNavPlus';

function PolarCareHeader({menu}){
    const {
        account
    } = useContext(ProfileContext);

    function getStoreName(){
        let store_data = helpers.getDefaultStore()

        if(store_data.hasOwnProperty('name')){
            return store_data.name;
        }
    }

    return (
        <>

            {/* Navbar */}
            <nav className="main-header navbar navbar-expand navbar-primary navbar-dark" style={{borderBottom: '0px'}}>
                {/* Left navbar links */}
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars" /></a>
                    </li>
                </ul>

                { helpers.isAuthenticated() ?
                <ul className="navbar-nav ml-auto">
                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","storeAdmin","storeView","storeCreate","storeEdit"]}>
                    <li className="nav-item dropdown">
                        <Link className="nav-link" to="/store/profile">
                            <i className="fas fa-store" />
                            <span className='d-none d-md-inline-block ml-2'>{getStoreName()}</span>
                        </Link>
                    </li>
                    </ProtectedComponent>

                    { getStoreName() ?
                    // <ProtectedComponent account={account} requiredPermissions={["superAdmin","inventoryCreate","inventoryAdjustCreate","salesOrderCreate","invoiceCreate","customerCreate","paymentReceiveCreate","shipmentCreate","purchaseOrderCreate","billCreate","purchaseReceiveCreate","vendorCreate","paymentMadeCreate","serviceHubCreate","productUnitCreate"]}>
                    // <li className="nav-item dropdown">
                    //     <a className="nav-link" data-toggle="dropdown" href="#" aria-expanded="true">
                    //         <i className="fas fa-plus-circle" />
                    //         {/* <span className='d-none d-md-inline-block ml-2'>New</span> */}
                    //     </a>
                    //     <div className="dropdown-menu dropdown-menu-md dropdown-menu-right" style={{left: 'inherit', right: 0, maxHeight: '400px', overflow: 'auto'}}>
                    //         <a className="dropdown-item mb-1" href="/item/form">
                    //             <i className="fas fa-tag mr-1" style={{width: '20px'}} /> Item
                    //         </a>
                    //         <a className="dropdown-item mb-1" href="/inventory-adjustment/form">
                    //             <i className="fas fa-percentage mr-1" style={{width: '20px'}} /> Inventory Adjustment
                    //         </a>
                            
                    //         {/* Sales */}
                    //         <div className="dropdown-divider" />
                    //         <a className="dropdown-item mb-1" href="/sales/form">
                    //             <i className="fas fa-shopping-cart mr-1" style={{width: '20px'}} /> Sales Order
                    //         </a>
                    //         <a className="dropdown-item mb-1" href="/invoices/form">
                    //             <i className="fas fa-file mr-1" style={{width: '20px'}} /> Invoice
                    //         </a>
                    //         <a className="dropdown-item mb-1" href="/customers/form">
                    //             <i className="fas fa-user-tag mr-1" style={{width: '20px'}} /> Customers
                    //         </a>
                    //         <a className="dropdown-item" href="/payment-receives/new">
                    //             <i className="fas fa-receipt mr-1" style={{width: '20px'}} /> Receive Payment
                    //         </a>
                    //         <a className="dropdown-item mb-1" href="/shipments/form">
                    //             <i className="fas fa-shipping-fast mr-2" /> Ship Order
                    //         </a>
                            
                    //         {/* Purchase Order */}
                    //         <div className="dropdown-divider" />
                    //         <a className="dropdown-item mb-1" href="/purchases/new">
                    //             <i className="fas fa-shopping-bag mr-1" style={{width: '20px'}} /> Purchase Order
                    //         </a>
                    //         <a className="dropdown-item mb-1" href="/bills/new">
                    //             <i className="fas fa-file-alt mr-1" style={{width: '20px'}} /> Bill
                    //         </a>
                    //         <a className="dropdown-item" href="/payment-made/new">
                    //             <i className="fas fa-money-check mr-1" style={{width: '20px'}} /> Pay Bill
                    //         </a>
                    //         <a className="dropdown-item" href="/vendors/form">
                    //             <i className="fas fa-store mr-1" style={{width: '20px'}} /> Vendor
                    //         </a>
                    //         <a className="dropdown-item mb-1" href="/purchase-receives/new">
                    //             <i className="fas fa-dolly-flatbed mr-1" style={{width: '20px'}} /> Receive Purchase
                    //         </a>

                    //         {/* PolarCare */}
                    //         <div className="dropdown-divider" />
                    //         <a className="dropdown-item mb-1" href="/service-requests/new">
                    //             <MdHandyman size={20} className='mr-2' />Service Request
                    //         </a>
                    //         <a className="dropdown-item mb-1" href="/product-units/new">
                    //             <i className="fas fa-tag mr-1" style={{width: '20px'}} /> Product Unit
                    //         </a>
                    //     </div>
                    // </li>
                    // </ProtectedComponent> 
                    <DropDownNavPlus account={account}/>
                    : ''}

                    <li className="nav-item dropdown">
                        <a className="nav-link" data-toggle="dropdown" href="#" aria-expanded="true">
                            {/* <i className="fas fa-portrait" /> */}
                            <i className="far fa-user-circle" />
                            {/* <span className='d-none d-md-inline-block ml-2'>{helpers.getUserName()}</span> */}
                        </a>
                        <div className="dropdown-menu dropdown-menu-md dropdown-menu-right" style={{left: 'inherit', right: 0}}>
                            <Link className="dropdown-item" to="/account/profile">
                                <i className="fas fa-user-edit mr-2" />{account?.user?.display_name ?? '[Profile Name]'}
                            </Link>

                            <div className="dropdown-divider" />
                            <Link className="dropdown-item" data-widget="control-sidebar" data-slide="true" onClick={() => appSession.logout()}><i className="fas fa-sign-out-alt mr-1"></i>Logout</Link>
                        </div>
                    </li>

                    {/* <li className="nav-item">

                        <a className="nav-link" data-widget="control-sidebar" data-controlsidebar-slide="true" href="#" role="button">
                            <i className="fas fa-th"></i>
                        </a>
                    </li> */}
                </ul> : ''
                }
            </nav>

            <PolarCareSideMenu menu={menu} />

            <Outlet />

            {/* Control Sidebar */}
            <aside className="control-sidebar control-sidebar-light">
                <div className='p-3'>
                    <h5>Apps</h5>
                    <hr/>
                    <a href='https://linkmo.co/' target='_blank' className='text-dark' onClick={(e) => e.preventDefault()}>
                        <div className="border rounded p-3 mb-2 text-center">
                        <div><img src={images.linkmo_logo} alt="Linkmo.co Logo" width={130}/></div>
                            <small>URL Shortener with QR Code</small>
                        </div>
                    </a>

                    {/* <a href='https://topventory.com/' target='_blank' className='text-dark'>
                        <div className="border rounded p-3 mb-2 text-center">
                            <div><img src={images.topventory_logo} alt="Topventory Logo" width={170}/></div>
                            <small>Sales & Inventory Software</small>
                        </div>
                    </a> */}

                    <a href='https://saver.asinso.net' className='text-dark' onClick={(e) => e.preventDefault()}>
                        <div className="border rounded p-3 mb-2 text-center">
                            <div><img src={images.asinso_logo} alt="Asinso Logo" width={120}/></div>
                            <small>Accounting Software</small>    
                            <span className='badge badge-primary'>Coming Soon</span>         
                        </div>
                    </a>

                    {/* <a href='https://saver.asinso.net' className='text-dark' onClick={(e) => e.preventDefault()}>
                        <div className="border rounded p-3 mb-2 text-center">
                            <div><img src={images.asinso_logo} alt="Asinso Logo" width={120}/></div>
                            <small>Savings & Credit Software</small>    
                            <span className='badge badge-primary'>Coming Soon</span>         
                        </div>
                    </a>

                    <a href='https://qrmakes.com' className='text-dark' onClick={(e) => e.preventDefault()}>
                        <div className="border rounded p-3 mb-2 text-center">
                            <div><b>QR Makes</b></div>    
                            <small>QR Code Generator</small>    
                            <span className='badge badge-primary'>Coming Soon</span>         
                        </div>
                    </a> */}
                </div>
            </aside>

        </>
    )
}

export default PolarCareHeader;